












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AppNav from './views/AppNav.vue';
import AppMap from './views/AppMap.vue';
import MapSelector from '@/components/menu/MapSelector.vue';
import FloorSlider from '@/components/FloorSlider.vue';
import { R6Map } from '@/maps';
import FloorLayer from '@/maps/FloorLayer';

@Component({
  components: {
    AppNav,
    AppMap,
    MapSelector,
    FloorSlider
  }
})
export default class App extends Vue {
  public heightVar = window.innerHeight * 0.01;
  private isOpen: boolean = true;

  private isMapSelectorModalActive = false;

  private changeMap(map: R6Map) {
    this.isMapSelectorModalActive = false;
    this.$store.dispatch('loadMap', { mapId: map.id });
  }

  public mounted() {
    window.addEventListener('resize', () => {
      this.heightVar = window.innerHeight * 0.01;
    });

    this.$i18n.locale = this.locale;
  }

  public get locale() {
    // return last set locale
    if (window.localStorage.locale) {
      return window.localStorage.locale;
    }
    // if can't retrive info from browser
    if (!navigator) {
      return 'en';
    }
    const locales = this.$i18n.messages;
    let locale = Object.keys(locales).find(key => {
      return navigator.language.toLowerCase().startsWith(key.toLowerCase());
    });
    if (!locale) {
      locale = 'en';
    }
    window.localStorage.locale = locale;
    return locale;
  }

  onSlide(event: { item: FloorLayer; value: number }[]) {
    let found = false;
    event.forEach(({ item, value }, i) => {
      if (value === 0) {
        item.config.enabled = false;
      } else {
        item.config.enabled = true;
        if (!found) {
          item.config.opacity = 1;
          found = true;
        } else {
          item.config.opacity = value;
        }
      }
    });
  }
}
